<template>
	<nk-page commercialAccess="System" policyClaims="Salary_SalaryPeriod_Copy" class="">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="salary"></nk-badge-item>
				<nk-badge-item type="system" modelValue="salary" :title="$t('forms.CopySalaryPeriod')"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="d-flex flex-column h-100">

			<div class="steps nk-card">
				<div v-for="step in Object.values(stepKeys)" class="step" @click="stepClicked(step)">
					<icon :class="{ 'step-unlocked': step.resultStatus === Status.Success, 'step-active': activeStep.key === step.key }" class="step-icon" :title="step.displayName" :name="step.icon" />
					<div class="d-none d-lg-block step-title">{{ step.displayName }}</div>
				</div>
			</div>

			<div class="steps-content nk-card mt-3 flex-grow-1 h-100">

				<div class="prepare-step" v-if="activeStep.key === stepKeys.beginning.key">

					<div class="prepare-step-container">

						<div class="operations ">
							<div class="d-flex justify-content-center">
								<icon style="font-size: 75px" name="fa-solid fa-calendar-days" class="primary"></icon>
								<div class="p-1 bg-white nk-border-radius" style="font-size:15px;position: relative;top: 67px;left:79px;height: 23px">
									<icon name="copy" class="primary "></icon>
								</div>
							</div>
							<div>
								<h4 class="text-center primary" style="margin-top: 25px">{{ $t('salary.period-copy.copy-period-title') }}</h4>
							</div>
							<div>
								<p class="font-weight-bold mt-5">{{ $t('salary.period-copy.copy-period-welcome') }}</p>
								<p class="font-weight-bold ">{{ $t('salary.period-copy.copy-period-explaining') }}</p>
							</div>
							<div class="nk-bg-lightWarning nk-border-lightWarning nk-border-radius mt-4 p-3">
								<div class="d-flex mb-2">
									<icon style="font-size: 17px" name="warning" class="text-warning ml-2"></icon>
									<label class="nk-color-lightWarning">{{ $t('salary.period-copy.attention') }}</label>
								</div>
								<div>
									<div class="d-flex mb-2">
										•
										<div class="mr-2">{{ $t('salary.period-copy.exit-warning') }}</div>
									</div>
									<div class="d-flex">
										•
										<div class="mr-2">{{ $t('salary.period-copy.current-period-data-editing-warning') }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>


				</div>
				<div class="prepare-step" v-if="activeStep.key === stepKeys.selectReference.key">

					<div class="prepare-step-container">

						<div class="operations ">
							<div class="form-container">
								<h4 class="text-center primary mb-5" style="margin-top: 25px">{{ $t('salary.period-copy.select-reference') }}</h4>

								<div class="w-100">
									<nk-col-form-group :label="$t('salary.period-copy.fiscal-period') + ':'" :labelSizes="{ sm: 3, md: 3 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }" :dataSizes="{ sm: 9, md: 9 }">
										<nk-dropdown v-model="localData.selectedResourceFiscalPeriod" :data="fiscalPeriods()" :options="componentOptions.dropFiscalPeriods" @update:modelValue="getSalaryPeriods" :tabindex="100" ref="fiscalPeriods"></nk-dropdown>
									</nk-col-form-group>
								</div>
								<div class="w-100 mb-5">
									<nk-col-form-group :label="$t('salary.period-copy.salary-period') + ':'" :labelSizes="{ sm: 3, md: 3 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }" :dataSizes="{ sm: 9, md: 9 }">
										<nk-dropdown v-model="localData.selectedResourceSalaryPeriod" :data="salaryPeriods" :options="componentOptions.dropFiscalPeriods" :tabindex="100" ref="fiscalPeriods"></nk-dropdown>
									</nk-col-form-group>
								</div>
								<div v-if="localData.selectedResourceSalaryPeriod">

									<label class="">{{ $t('salary.period-copy.from-salary-period-copy-these', { name: localData.selectedResourceSalaryPeriod.displayName }) }}</label>
									<nk-checkbox class="" type="checkbox" :tabindex="200" :options="componentOptions.helperTableChb" v-model="localData.copyHelper" />
									<nk-checkbox class="" type="checkbox" :tabindex="202" :options="componentOptions.settingChb" v-model="localData.copySettings" />
									<nk-checkbox class="" type="checkbox" :tabindex="204" :options="componentOptions.usageChb" v-model="localData.copyUsage" />
								</div>

							</div>
						</div>
					</div>


				</div>
				<div class="h-100" v-if="activeStep.key === stepKeys.personnelList.key">
					<ag-grid :options="componentOptions.personnelTable" :data="contracts" v-model="localData.selectedContracts" @destroyed="() => contracts = []" ref="table"></ag-grid>
				</div>
				<div class="prepare-step" v-if="activeStep.key === stepKeys.review.key">

					<div class="prepare-step-container">

						<div class="operations ">
							<div class="mb-5">
								<h4 class="text-center primary" style="margin-top: 10px">{{ $t('salary.period-copy.steps.Review') }}</h4>
							</div>
							<div class="px-3">
								<div class="d-inline-flex w-100">
									<label class="gray-text " style="white-space: nowrap">{{ $t('salary.period-copy.start-period') }}</label>
									<hr class="w-100 gray-text " style="border-top:1px dashed lightgray" />
									<label class="" style="white-space: nowrap">{{ localData.selectedResourceSalaryPeriod?.displayName }}</label>
								</div>
								<div class="d-inline-flex w-100">
									<label class="gray-text " style="white-space: nowrap">{{ $t('salary.period-copy.destination-period') }}</label>
									<hr class="w-100 gray-text " style="border-top:1px dashed lightgray" />
									<label class="" style="white-space: nowrap">{{ getSalaryPeriod.displayName }}</label>
								</div>
								<div class="d-inline-flex w-100">
									<label class="gray-text " style="white-space: nowrap">{{ $t('salary.period-copy.personnel-count') }}</label>
									<hr class="w-100 gray-text " style="border-top:1px dashed lightgray" />
									<label class="" style="white-space: nowrap">{{ localData.selectedContracts.length }}</label>
								</div>
								<div class="d-inline-flex w-100">
									<label class="gray-text " style="white-space: nowrap">{{ $t('salary.period-copy.copy-monthly-usage') }}</label>
									<hr class="w-100 gray-text " style="border-top:1px dashed lightgray" />
									<label class="" style="white-space: nowrap">{{ $t(`boolean-yes-no.${localData.copyUsage}`) }}</label>
								</div>
								<div class="d-inline-flex w-100">
									<label class="gray-text " style="white-space: nowrap">{{ $t('salary.period-copy.copy-contract-tables') }}</label>
									<hr class="w-100 gray-text " style="border-top:1px dashed lightgray" />
									<label class="" style="white-space: nowrap">{{ $t(`boolean-yes-no.${localData.copyHelper}`) }}</label>
								</div>
								<div class="d-inline-flex w-100">
									<label class="gray-text " style="white-space: nowrap">{{ $t('salary.period-copy.copy-settings') }}</label>
									<hr class="w-100 gray-text " style="border-top:1px dashed lightgray" />
									<label class="" style="white-space: nowrap">{{ $t(`boolean-yes-no.${localData.copySettings}`) }}</label>
								</div>
							</div>
							<div class="nk-bg-lightWarning nk-border-lightWarning nk-border-radius mt-4 p-3">
								<div class="d-flex mb-2">
									<icon style="font-size: 17px" name="warning" class="text-warning ml-2"></icon>
									<label class="nk-color-lightWarning">{{ $t('salary.period-copy.attention') }}</label>
								</div>
								<div>
									<div class="d-flex mb-2">
										•
										<div class="mr-2">{{ $t('salary.period-copy.replace-duplicate-personnel') }}</div>
									</div>
									<div class="d-flex">
										•
										<div class="mr-2">{{ $t('salary.period-copy.replace-contract-table') }}</div>
									</div>
									<div class="d-flex mb-4">
										•
										<div class="mr-2">{{ $t('salary.period-copy.replace-settings') }}</div>
									</div>
									<nk-checkbox class="" type="checkbox" :tabindex="400" :options="componentOptions.textApproval" v-model="localData.textApproval" />
								</div>
							</div>
						</div>
					</div>


				</div>


			</div>

			<div class="step-buttons mt-3">
				<nk-button class="step-button" :options="componentOptions.nextButton" @click="nextButtonClicked" :tabindex="201"></nk-button>
				<nk-button v-if="activeStep.index > 0" class="step-button" :options="componentOptions.prevButton" @click="prevButtonClicked" :tabindex="202"></nk-button>
				<!--				<nk-button v-if="activeStep.index === totalSteps-1 || Object.values(stepKeys).every(x => x.resultStatus === Status.Success)" class="step-button" :options="componentOptions.finishButton" @click="finishButtonClicked" :tabindex="203"></nk-button>-->
			</div>

		</div>

	</nk-page>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { DocumentClosingTypes, DocumentGroups } from '~/enums/system'
	import type { Document, DocumentSummaryInfo } from '~/classes/system/document'
	import { ClosingAccount } from '~/classes/system/document'
	import { Code, IResponse, IResponseList } from '~/interfaces/base'
	import CloseTemporaryPermanentAccounts from '@/views/documents/closing-document/close-temporary-permanent-accounts.vue'
	import AutoAccountModify from '@/views/accounts/auto-accounts-modify.vue'
	import { IStringMap, SalaryPeriod } from '@/classes/salary/salary-period'
	import { _NikanWait } from '@/plugins/nikan-waiting-plugin'
	import { mapGetters, mapState } from 'vuex'
	import { FiscalPeriod } from '@/classes/system/fiscal-period'
	import merge from 'lodash/merge'
	import validators, { Checker, VCustom, VRequiredIfValue } from '@/statics/validators'
	import { Contract } from '@/classes/salary/contract'
	import { TYPE } from 'vue-toastification'

	class StepKeys {
		beginning!: Step
		selectReference!: Step
		personnelList!: Step
		review!: Step
	}

	enum Status {
		Success = 'success',
		Error = 'error',
		Pending = 'pending'
	}

	enum Keys {
		Beginning = 'Beginning',
		SelectReference = 'SelectReference',
		PersonnelList = 'PersonnelList',
		Review = 'Review',
	}

	class Step {
		key: Keys
		displayName: string
		icon: string
		updateCompKey!: string
		index: number
		resultStatus!: Status
		resultMessage!: string | null

		constructor(key: Keys = Keys.Beginning, displayName: string = '', icon: string = '', index: number = 0, resultStatus: Status = Status.Pending, active: boolean = false, resultMessage: string | null = null) {
			this.displayName = displayName
			this.icon = icon
			this.index = index
			this.resultStatus = resultStatus
			this.key = key
			this.resultMessage = resultMessage
		}
	}

	export default defineComponent({
		name: 'salary-copy-period',
		modal: {
			size: 'custom',
			width: 1080,
			height: 800,
			stateUID: 'modal-salary-copy-period',
			helpTag: 'SalaryCopyPeriod'
		},
		props: {
			options: Object
		},
		components: {},
		computed: {
			...mapGetters({
				fiscalPeriods: 'fiscalPeriods/getByCompanyId',
				currentUserDetails: 'useraccount/currentUserDetails',
				getAllPeriods: 'salaryPeriods/all',
				getSalaryPeriod: 'appContext/getSalaryPeriod',
			}),
			totalSteps() {
				return Object.values(this.stepKeys).length
			}
		},
		watch: {
			activeStep: {
				deep: true,
				handler(value: Step) {
					this.activeStepHandler(value)

				}
			},
		},
		data() {
			return {
				contracts: [] as Contract[],
				prepareStepCounter: 0,
				Status,
				stepKeys: new StepKeys(),
				// steps: [] as Step[],
				unluckedSteps: [] as Step[],
				activeStep: new Step(),
				lastStep: new Step(),
				waiting: null as any,
				document: null as Document | null,
				documentNumber: '' as Code,
				localData: {
					selectedResourceFiscalPeriod: undefined as FiscalPeriod | undefined,
					selectedResourceSalaryPeriod: undefined as SalaryPeriod | undefined,
					selectedContracts: [] as Contract[],
					textApproval: false,
					copyHelper: false,
					copySettings: false,
					copyUsage: false
				},
				salaryPeriods: [] as SalaryPeriod[],
				settings: {} as any,
				componentOptions: {
					personnelTable: {
						id: 'salary-copy-period-personnel-table',
						pagination: false,
						groupIncludeTotalFooter: false,
						cellSelectionAggReport: false,
						enterToSelect: false,
						rowSelection: {
							mode: 'multiRow',
							checkboxes: true,
							headerCheckbox: true
						},
						sideBar: 'none',
						focusAndSelect: { allowFocus: true, },

						columnDefs: [
							{
								field: 'rowNumber',
								headerName: this.$t('row-number'),
							},
							{
								field: 'personnel',
								headerName: this.$t('salary.period-copy.personnel-code'),
								contentType: 'enum',
								valueFormatter: (params: any) => {
									return params.value.code
								}
							},
							{
								field: 'personnel',
								headerName: this.$t('salary.period-copy.first-name'),
								contentType: 'enum',
								valueFormatter: (params: any) => params.value.firstName
							},
							{
								field: 'personnel',
								headerName: this.$t('salary.period-copy.last-name'),
								contentType: 'enum',
								valueFormatter: (params: any) => params.value.lastName
							},
							{
								field: 'personnel',
								headerName: this.$t('salary.period-copy.national-code'),
								contentType: 'enum',
								width: 100,
								valueFormatter: (params: any) => params.value.nationalCode
							},

						]
					},
					dropFiscalPeriods: {},
					helperTableChb: {
						title: this.$t('salary.period-copy.helper-tables')
					},
					textApproval: {
						title: this.$t('salary.period-copy.approval-text')
					},
					settingChb: {
						title: this.$t('salary.period-copy.salary-settings')

					},
					usageChb: {
						title: this.$t('salary.period-copy.usage-settings')

					},
					nextButton: {
						title: this.$t('closing-document.buttons.next'),
						shortcut: $sc.find('next', 'install'),
						icon: 'arrow-left',
						beginOfGroup: true,
						isPrimary: true
					},
					prevButton: {
						title: this.$t('closing-document.buttons.prev'),
						shortcut: $sc.find('prev', 'install'),
						icon: 'arrow-right',
						beginOfGroup: true,
						isPrimary: true
					},
					finishButton: {
						title: this.$t('closing-document.buttons.finish'),
						shortcut: $sc.find('save'),
						icon: 'check',
						beginOfGroup: true,
						isPrimary: true
					},
				}
			}
		},
		mounted() {
			this.localData.selectedResourceFiscalPeriod = this.fiscalPeriods().find((x: any) => x.id === this.currentUserDetails.fiscalPeriodId)
			this.getSalaryPeriods(this.localData.selectedResourceFiscalPeriod)
		},
		created() {
			merge(this.settings, this.options)
			this.stepKeys = Object.assign(new StepKeys(), {
				beginning: new Step(Keys.Beginning, this.$t(`salary.period-copy.steps.${Keys.Beginning}`), 'book-open-reader', 0, Status.Success, true),

				selectReference: new Step(Keys.SelectReference, this.$t(`salary.period-copy.steps.${Keys.SelectReference}`), 'book-sparkles', 1, Status.Pending, false),

				personnelList: new Step(Keys.PersonnelList, this.$t(`salary.period-copy.steps.${Keys.PersonnelList}`), 'list', 2, Status.Pending, false),

				review: new Step(Keys.Review, this.$t(`salary.period-copy.steps.${Keys.Review}`), 'magnifying-glass', 3, Status.Pending, false),

			})
			this.activeStep = this.stepKeys.beginning
			this.stepClicked(this.activeStep)

			// this.unluckedSteps = [steps[0]]
		},
		methods: {

			getSalaryPeriods(selectedFiscalPeriod: FiscalPeriod | any) {
				if (selectedFiscalPeriod)
					post(Endpoints.getUrl('salaryPeriod.list'), { fiscalPeriodId: selectedFiscalPeriod.id }).then((res: IResponseList<SalaryPeriod>) => {
						this.salaryPeriods = res.data.items.map(x => { return { ...x, name: x.displayName } })
						if (this.settings.selectedSourcePeriod)
							this.localData.selectedResourceSalaryPeriod = this.salaryPeriods.find(x => x.id === this.settings.selectedSourcePeriod.id)
					})
			},
			getContracts() {
				const wait = this.$wait(this.$el)
				if (this.localData.selectedResourceSalaryPeriod)
					post(Endpoints.getUrl('contract.list'), { salaryPeriodId: this.localData.selectedResourceSalaryPeriod.id }).then((res: IResponseList<Contract>) => {
						this.contracts = res.data.items
					}).catch(() => { }).finally(() => wait.end())
			},
			submit() {
				const wait = this.$wait(this.$el)

				const payload = {
					"sourceSalaryPeriodId": this.localData.selectedResourceSalaryPeriod?.id,
					"destinationSalaryPeriodId": this.getSalaryPeriod.id,
					"copyMonthlyUsage": this.localData.copyUsage,
					"copyAuxiliaryTables": this.localData.copyHelper,
					"contractIds": this.localData.selectedContracts.map(x => x.id),
					"copySettings": this.localData.copySettings
				}
				post(Endpoints.getUrl('salaryPeriod.copy'), payload).then((res: IResponse<any>) => {
					this.$toast(this.$t('salary.period-copy.m.submit-successfully'), { type: TYPE.SUCCESS })
					this.resolve()
				}).catch(() => { }).finally(() => wait.end())
			},
			stepResultHandler(result: { status: Status, message: string } | null) {
				if (result) {
					this.activeStep.resultStatus = result.status
					this.activeStep.resultMessage = result.message
					if (result.status !== Status.Success) this.activeStep = this.lastStep
				}
			},
			activeStepHandler(value: Step) {
				switch (value.key) {
					case Keys.Review: {
						this.componentOptions.nextButton.title = this.$t('closing-document.buttons.submit')
						this.componentOptions.nextButton.icon = 'save'
					}
						break
					default: {
						this.componentOptions.nextButton.title = this.$t('closing-document.buttons.next')
						this.componentOptions.nextButton.icon = 'arrow-left'
					}
				}
			},
			refreshButtonHandler() {
				this.runStepOperation(this.activeStep.key)
			},
			autoAccountButtonHandler(button: any, page: any, e: any) {
				e.preventDefault()
				this.showModal({
					component: AutoAccountModify,
					options: { filterByForm: this.activeStep.key }
				}).catch((e) => { })
			},
			runStepOperation(key: Keys) {
				const stepOperation: IStringMap<Function> = {
					[Keys.Beginning]: () => this.stepKeys.beginning.updateCompKey = (new Date()).toString(),
					[Keys.SelectReference]: () => this.stepKeys.selectReference.updateCompKey = (new Date()).toString(),
					[Keys.PersonnelList]: this.getContracts,
					[Keys.Review]: () => this.submit,
				}
				return stepOperation[key]()
			},
			stepClicked(step: Step): void {
				const withinSteps = Object.values(this.stepKeys).filter(x => step.index > x.index)
				if (step && (this.activeStep.resultStatus === Status.Success || this.activeStep.index >= step.index) && (!withinSteps.length || withinSteps.every((x, ind: number) => x.resultStatus === Status.Success))) {
					this.activeStep = step
					this.lastStep = step
					this.runStepOperation(step.key)
				}
			},
			validation(validationObj: any) {
				let checker = new Checker((key: string) => {
					const messages: IStringMap = {
						selectedResourceSalaryPeriod: this.$t('salary.period-copy.validation-messages.selectedResourceSalaryPeriod'),
						selectedResourceFiscalPeriod: this.$t('salary.period-copy.validation-messages.selectedResourceFiscalPeriod'),
						selectedContracts: this.$t('salary.period-copy.validation-messages.selectedContracts'),
						textApproval: this.$t('salary.period-copy.validation-messages.textApproval'),
					}
					return messages[key]
				})
				let errors = checker.test(this.localData, validationObj)
				//@ts-ignore
				this.validationToast(errors)
				return errors.length === 0
			},
			nextButtonClicked() {
				const stepOperation: IStringMap<any> = {
					[Keys.Beginning]: {},
					[Keys.SelectReference]: {
						selectedResourceFiscalPeriod: validators('required'),
						selectedResourceSalaryPeriod: validators('required'),
					},
					[Keys.PersonnelList]: {
						selectedContracts: validators(new VRequiredIfValue('selectedContracts', () => {
							return !this.localData.selectedContracts.length && false
						}
						)),
					},
					[Keys.Review]: {
						textApproval: validators(new VCustom((value: any, obj: any) => {
							return value
						},
							(name: string) => {
								return this.$t('msg.required', [name])
							}
						))
					},
				}
				this.stepResultHandler({ status: this.validation(stepOperation[this.activeStep.key]) ? Status.Success : Status.Error, message: '' })
				if (this.activeStep.resultStatus === Status.Success) {
					const nextStep = Object.values(this.stepKeys).find(x => x.index === this.activeStep.index + 1) as Step
					if (nextStep) {
						this.stepClicked(nextStep)
					} else {
						this.submit()
					}
				}
			},
			prevButtonClicked() {
				const previousStep = Object.values(this.stepKeys).find(x => x.index === this.activeStep.index - 1) as Step
				if (previousStep) {
					this.stepClicked(previousStep)
				}
			},
			finishButtonClicked() { },
		}
	})
</script>

<style lang="less" scoped>
	@import (reference) "../../../styles/site.config.less";

	.gray-text {
		color: #a4a4a4;
		background-color: transparent;
	}

	.primary {
		color: @primary
	}

	.steps {
		display: flex;
		align-items: center;
		justify-content: space-around;
		overflow-x: auto;
		overflow-y: hidden;

		.step {
			position: relative;
			flex: 1;
			cursor: pointer;

			&::before {
				content: " ";
				border-top: 1px solid @primary;
				width: 100%;
				top: 19px;
				left: 0;
				display: block;
				position: absolute;
			}

			.step-icon {
				border-radius: 50%;
				background-color: #ffffff;
				width: 40px;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				overflow: hidden;
				position: relative;
				z-index: 1;
				margin: auto;
				color: @primary;
				border: 1px solid @primary;
				transition: background-color 250ms ease-in-out;


				&.step-unlocked {
					background-color: lighten(@primary, 20%);
					color: #ffffff;
				}

				&.step-active {
					background-color: @primary;
					color: #ffffff;
				}

			}

			.step-title {
				color: @primary;
				text-align: center;
				font-weight: bold;
			}

		}
	}

	.steps-content {
		.prepare-step {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;

			.prepare-step-container {
				display: flex;
				flex-direction: column;
				padding: 25px;
				border-radius: 13px;
				border: 1px solid var(--Background, #E7ECEF);
				box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
				width: 400px;
			}

			.bullet-point {
				font-size: 17px;
				height: 25px;
				width: 25px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.prepare-step-title {
				font-size: 16px;
				font-weight: bold;
				align-self: flex-start;
				border-bottom: 1px solid #aaa;
				padding-bottom: 18px;
				width: 100%;
			}

			.operations {
				.operation {

					margin: 10px 0;

					.loader-line {
						width: 100%;
						height: 3px;
						position: relative;
						overflow: hidden;
						background-color: #ddd;
						margin-top: 7px;
						-webkit-border-radius: 20px;
						-moz-border-radius: 20px;
						border-radius: 20px;
					}

					.loader-line:before {
						content: "";
						position: absolute;
						left: -50%;
						height: 3px;
						width: 40%;
						background-color: @primary;
						-webkit-animation: lineAnim 1s linear infinite;
						-moz-animation: lineAnim 1s linear infinite;
						animation: lineAnim 1s linear infinite;
						-webkit-border-radius: 20px;
						-moz-border-radius: 20px;
						border-radius: 20px;
					}

					@keyframes lineAnim {
						0% {
							left: -40%;
						}

						50% {
							left: 20%;
							width: 80%;
						}

						100% {
							left: 100%;
							width: 100%;
						}
					}

					.operation-title {
						font-size: 16px;

						&.success {
							color: #00c576 !important;
						}

						&.error {
							color: #ff1010 !important
						}
					}
				}
			}

		}

	}

	.step-buttons {
		display: flex;
		flex-direction: row-reverse;
		gap: 5px;

		.step-button {
			width: 100px;
		}
	}
</style>